export type MainLift = 'squat' | 'bench' | 'row' | 'ohp' | 'deadlift';
export type WorkoutKind = 'A' | 'B';

export interface Prescription {
  lift: MainLift;
  sets: number;
  reps: number;
}

/** Official StrongLifts 5×5: A = Squat, Bench, Row; B = Squat, OHP, Deadlift 1×5. */
export const WORKOUTS: Record<WorkoutKind, readonly Prescription[]> = {
  A: [
    { lift: 'squat', sets: 5, reps: 5 },
    { lift: 'bench', sets: 5, reps: 5 },
    { lift: 'row', sets: 5, reps: 5 },
  ],
  B: [
    { lift: 'squat', sets: 5, reps: 5 },
    { lift: 'ohp', sets: 5, reps: 5 },
    { lift: 'deadlift', sets: 1, reps: 5 },
  ],
};

/** Lifts that start from the floor and so can't warm up with the empty bar. */
export const FLOOR_LIFTS: ReadonlySet<MainLift> = new Set<MainLift>(['deadlift', 'row']);
